import { render } from "./PredefinedColors.vue?vue&type=template&id=caf6f84a"
import script from "./PredefinedColors.vue?vue&type=script&lang=js"
export * from "./PredefinedColors.vue?vue&type=script&lang=js"
script.render = render

export default script